import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useNavState } from '@/common/navState/NavStateContext';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const IncRuleList = ({ incDataSrcId }) => {
  const { navState } = useNavState();

  const augRowsReq = useCallback(
    EntityUtils.parentFilterAugRowsReq('INC_DATA_SRC', incDataSrcId || navState.incDataSrcId),
    [incDataSrcId || navState.incDataSrcId]
  );

  return (
    <EntityList entity="INC_RULE" augRowsReq={augRowsReq} />
  );
};
